<template>
  <ShImage
    :srcset="srcset"
    :alt="imageAlt"
    :loading="loadingImage"
    :round="round"
    :aspect-ratio="aspectRatio"
  />
</template>

<script>
import { ShImage } from '@sohohouse/design-system'
import sources from '~/constants/sources'
import fraction from '~/constants/fraction'

export default {
  name: 'cloudinary-image',

  components: {
    ShImage
  },

  props: {
    imageSource: {
      type: String,
      require: true
    },
    imageAlt: {
      type: String,
      default: ''
    },
    mobileSource: {
      type: String
    },
    fraction: {
      type: Number,
      default: 1
    },
    aspectRatio: {
      type: String
    },
    round: {
      type: Boolean
    },
    // To enable low quality image placeholders
    useLQIP: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      sources,
      baseUrl: 'https://res.cloudinary.com/soho-house/image/upload',
      params: [
        'f_auto', // param to detect browser and use the most efficient image format
        'q_auto',
        'fl_progressive:steep'
      ]
    }
  },

  computed: {
    fractionNumber () {
      return this.$device.isMobile ? fraction.oneFr : this.fraction
    },

    srcset () {
      const srcset = this.sources.map(source => {
        const path = this.getSourceForDevice(source.media)
        const fractionWidth = this.fractionWidth(source.width)
        const params = [...this.params, `w_${fractionWidth}`]

        return `${this.generateUrl(params, path)} ${fractionWidth}w`
      }).join(',')

      // add the loading image into the srcset
      if (this.useLQIP) {
        return `${this.loadingImage} 220w, ${srcset}`
      }

      return srcset
    },

    loadingImage () {
      const params = ['e_blur:1000', 'q_1', 'f_auto', 'w_500']

      return this.useLQIP && this.generateUrl(params, this.imageSource)
    }
  },

  methods: {
    getImagePath (url) {
      if (!url) return ''

      const [, path] = url.split(this.baseUrl)
      return path
    },

    fractionWidth (width) {
      return Math.round(width / this.fractionNumber)
    },

    getSourceForDevice (media) {
      switch (media) {
        case '--mobile-sm':
        case '--mobile': {
          return this.mobileSource || this.imageSource
        }
        default: {
          return this.imageSource
        }
      }
    },

    generateUrl (params, path = '') {
      return `${this.baseUrl}/${params.join(',')}${this.getImagePath(path)}`
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  width: 100%;
  height: 100%;
}
</style>
